import { CompanyNameViewModel, PerformanceSummary, WellInfo } from '../services/nswag/nswagclient';
import { BaseEntity } from './baseEntity';

export class Simulation implements BaseEntity {
    id = '';

    activities?: SimulationActivity[];
    chemicals?: SimulationChemical[];
    defaults?: SimulationDefault;
    expenses?: SimulationExpense[];
    fluidSummary?: SimulationFluidSummary;
    goals?: SimulationGoals;
    header?: SimulationHeader;
    performance?: PerformanceSummary;
    siteDetails?: SimulationSiteDetails;
    wellInfo?: WellInfo;
}

export class SimulationActivity {
    guid?: string;
    activity?: string;
    isDepthStart?: boolean;
    isDepthEnd?: boolean;
    depthStart?: number;
    depthEnd?: number;
    duration?: number;
    pipeSpeed?: number;
    circulationRate?: number;
    returnRate?: number;

    /* Calculated Fields */
    calcAv?: number;
    calcRe?: number;
    calcDepth?: number;
    calcRelativeTime?: number;
    calcFlowbackBbls?: number;
    calcPumpedBbls?: number;
    calcPlugNumber?: number;
}

export class SimulationChemical {
    id?: string;
    chemicalId?: string;
    chemicalFluidSystemId?: string;
    cost?: number;
    depthOrPlug?: number;
    dosage?: number;
    hasDepth?: boolean;
    shutdownOnPooh?: boolean;
}

export class SimulationDefault {
    duration?: number;
    pipeSpeed?: number;
    circulationRate?: number;
    returnRate?: number;
}

export class SimulationExpense {
    id?: string;
    description?: string;
    costPerFactor?: number;
    expenseCostFactorId?: string;
}

export class SimulationFluidSummary {
    fluidDensity?: number;
    costPerBbl?: number;
    fluidTypeId?: string;
    slwViscosity?: number;
    loopTypeId?: string;
    barrelCount?: number;
}

export class SimulationGoals {
    cost?: number;
    hours?: number;
}

export class SimulationHeader {
    simulationId?: string;
    customer?: CompanyNameViewModel;
    companyId?: string;
    name?: string;
    majorVersion?: number;
    minorVersion?: number;
    revisionVersion?: number;
    timestamp?: number;
}

export class SimulationSiteDetails{
    wellName?: string;
    api?: string;
    districtId?: string;
    stateId?: string;
    countyId?: string;
    field?: string;
    procedure?: string;
    wellType?: string;
}
